export const searchThemesFromCompanies = {
    description: 'You can check the themes to which a selected company belongs',
    subtitle1: 'SELECT a COMPANY',
    searchByCompany: 'Search from company name',
    selectFromFavoriteCompany: 'Select from your favorite companies list',
    subtitle2: 'Themes which the company belongs to',
    selected: 'Selected',
    searchTableSelect1: 'Theme Name',
    userInputPlaceholder: 'Please enter a keyword',

    // 企業が保有するテーマ一覧のCSV
    csvColumn1: 'Company Name',
    csvColumn2: 'Theme',
    csvColumn3: 'Total number of patent applications in theme',
    csvColumn4: 'Total number of registered patents in theme',
    csvColumn6: 'Number of patent applications of the company',
    csvColumn7: 'Number of registered patents of the company',
    csvColumn10: 'Number of material patents of the company',
    csvColumn11: 'Ratio of material patents of the company',
    csvColumn8: 'Number of citations by selected company',
    csvColumn9: 'Ratio of patent applications owned by the specified company',

    // 企業が保有するテーマ一覧
    column1: 'Theme',
    column2: 'Total number of patent applications in theme',
    column3: 'Total number of registered patents in theme',
    column5: 'Number of patent applications of the company',
    column6: 'Number of registered patents of the company',
    column9: 'Number of material patents of the company',
    column10: 'Ratio of material patents of the company',
    column7: 'Number of citations by selected company',
    column8: 'Ratio of patent applications owned by the specified company',

    search: 'Analyze the selected theme'
}
